import api from "app/api";
import { EventGroupItem } from "features/event-groups/eventGroupApi";

interface DragDropUpdateParams {
  event_id: number;
  new_event_group_id: number;
}

interface GroupShiftParams {
  group_ids: number[];
  minutes_offset: number;
}

interface GroupEditParams {
  event_group_ids: number[];
  new_start_time?: string;
  new_boat_id?: number;
  new_program_id?: number;
}

interface GroupEditEventsParams {
  event_ids: number[];
  limits?: any;
  variants?: any;
  seating_layouts?: any;
  private?: boolean;
}

interface DuplicateEventParams {
  event_id: number;
  new_start_time: string;
}

interface DragDropNewParams extends EventGroupItem {
  event_id: number;
}

export const dragDropUpdate = async (params: DragDropUpdateParams) => {
  return api.post("/event-editor/drag-drop-update", params);
};

export const dragDropNew = async (params: DragDropNewParams) => {
  return api.post("/event-editor/drag-drop-new", params);
};

export const groupShift = async (params: GroupShiftParams) => {
  return await api.post("/event-editor/group-shift", params);
};

export const groupEdit = async (params: GroupEditParams) => {
  return api.post("/event-editor/group-edit", params);
};

export const groupEditEvents = async (params: GroupEditEventsParams) => {
  return api.post("/event-editor/group-edit-events", params);
};

export const groupEventCancel = async (eventIds: number[]) => {
  return api.post("/event-editor/group-event-cancel", {
    event_ids: eventIds,
  });
};

export const groupEventActive = async (eventIds: number[]) => {
  return api.post("/event-editor/group-event-activate", {
    event_ids: eventIds,
  });
};

export const groupEventGroupCancel = async (groupIds: number[]) => {
  return api.post("/event-editor/group-event-group-cancel", {
    group_ids: groupIds,
  });
};

export const groupEventGroupActive = async (groupIds: number[]) => {
  return api.post("/event-editor/group-event-group-activate", {
    group_ids: groupIds,
  });
};

export const groupEventDelete = async (eventIds: number[], force?: boolean) => {
  return api.post("/event-editor/group-event-delete", {
    event_ids: eventIds,
    force: force ? 1 : 0,
  });
};

export const groupEventGroupDelete = async (
  groupIds: number[],
  force?: boolean
) => {
  return api.post("/event-editor/group-event-group-delete", {
    group_ids: groupIds,
    force: force ? 1 : 0,
  });
};

export const duplicateEvent = async (params: DuplicateEventParams) => {
  return api.post("/event-editor/duplicate-event", params);
};
